import React from 'react'
import Reports from './Reports'
import { useTranslation } from 'react-i18next'

const CustomerLevel = () => {
  const { t } = useTranslation()
  const columns = [
    {
      title: ('reports.customerLevel.lastModifiedDate'),
      title1: 'reports.customerLevel.lastModifiedDate',
      field: 'lastModifiedDate',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.customerLevel.transmittedDate'),
      title1: 'reports.customerLevel.transmittedDate',
      field: 'transmittedDate',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.customerLevel.customerId'),
      title1: 'reports.customerLevel.customerId',
      field: 'accountLevel1',
      headerAlign: 'center',
      editable: 'never'
    },
    {
      title: ('reports.customerLevel.jobNumber'),
      title1: 'reports.customerLevel.jobNumber',
      field: 'jobId',
      sortable: false,
      editable: 'never'
    },
    {
      title: ('reports.customerLevel.totalKeying'),
      title1: 'reports.customerLevel.totalKeying',
      field: 'keyedTime',
      sortable: false,
      editable: 'never'
    },
    {
      title: ('reports.customerLevel.totalVerifyTime'),
      title1: 'reports.customerLevel.totalVerifyTime',
      field: 'totalVerifyTime',
      sortable: false,
      editable: 'never'
    },
    {
      title: ('reports.customerLevel.totalKeystroke'),
      title1: 'reports.customerLevel.totalKeystroke',
      field: 'keyStrokeCount',
      sortable: false,
      editable: 'never'
    },
    {
      title: ('reports.customerLevel.totalBoxes'),
      title1: 'reports.customerLevel.totalBoxes',
      field: 'totalBoxCount',
      headerAlign: 'center',
      textAlign: 'center',
      sortable: false,
      editable: 'never'
    },
    {
      title: ('reports.customerLevel.totalFiles'),
      title1: 'reports.customerLevel.totalFiles',
      field: 'totalRecordCount',
      headerAlign: 'center',
      textAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.customerLevel.kph'),
      title1: 'reports.customerLevel.kph',
      field: 'kphTime',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.customerLevel.files'),
      title1: 'reports.customerLevel.files',
      field: 'filesByHour',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.customerLevel.templateName'),
      title1: 'reports.customerLevel.templateName',
      field: 'templateName',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.customerLevel.orderNumber'),
      title1: 'reports.customerLevel.orderNumber',
      field: 'orderNumber',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    }
  ]
  return <>
    <Reports columns={columns} pageTitle={t('reports.customerLevel.title')} isEmployeeLevel={false}/>
  </>
}

export default CustomerLevel